import { useCallback } from "react";

import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import * as Converter from "../converter";
import * as Schema from "../schema";

import type * as Type from "../type";

type Props = {
	hotelID: string;
	date: string;
};

type Result = {
	optionPmsGetAvailableOptionListQueryData:
		| Type.QueryData.OptionPmsGetAvailableOptionList.OptionPmsGetAvailableOptionListQueryData
		| undefined;
	onQueryOptionPmsGetAvailableOptionList: (props: Props) => Promise<void>;
};

export const useOptionPmsGetAvailableOptionListQuery = ({ hotelID, date }: Props): Result => {
	const { data, refetch } = useCustomSuspenseQuery(Schema.OPTION_PMS_GET_AVAILABLE_OPTION_LIST_FOR_OPTION_PMS, {
		variables: { hotelID, date },
	});

	/**
	 * refetch をラップし、同期的にデータを取得する
	 */
	const onQueryOptionPmsGetAvailableOptionList = useCallback(
		async ({ hotelID, date }: { hotelID: string; date: string }) =>
			await refetch({ hotelID, date })
				.then(({ data }) => {
					if (!data) throw new Error("optionPmsGetAvailableOptionList is undefined");
				})
				.catch(() => {
					throw new Error();
				}),
		[refetch],
	);

	const optionPmsGetAvailableOptionListQueryData = Converter.useOptionPmsGetAvailableOptionListConverter({
		optionPmsGetAvailableOptionListServerData: data,
	});

	return {
		optionPmsGetAvailableOptionListQueryData:
			optionPmsGetAvailableOptionListQueryData?.optionPmsGetAvailableOptionListQueryData,
		onQueryOptionPmsGetAvailableOptionList,
	};
};
